<template>
  <div class="empty-state" role="status">
    <svg class="empty-illustration" viewBox="0 0 120 88" fill="none" aria-hidden="true" focusable="false">
      <ellipse cx="61" cy="77" rx="32" ry="4" fill="#f1f4f7" />
      <rect x="28" y="14" width="49" height="54" rx="7" transform="rotate(-10 52.5 41)" fill="#f5f7fa" stroke="#e1e6ed" stroke-width="1.5" />
      <rect x="42" y="23" width="49" height="49" rx="7" fill="#fff" stroke="#d9e0e8" stroke-width="1.5" />
      <path d="M54 37h15M54 47h25M54 57h18" stroke="#e1e6ed" stroke-width="3" stroke-linecap="round" />
      <rect x="75" y="23" width="8" height="3" rx="1.5" class="empty-accent" />
    </svg>
    <p class="empty-title">{{ title }}</p>
    <p v-if="description" class="empty-description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '暂无数据' },
    description: { type: String, default: '' }
  }
}
</script>

<style scoped lang="scss">
.empty-state { display: flex; flex-direction: column; align-items: center; padding: 24px 16px 28px; line-height: 1.5; }
.empty-accent { fill: $theme-primary-border; }
.empty-illustration { display: block; width: 96px; height: 70px; margin-bottom: 8px; }
.empty-title { margin: 0; color: $theme-text-empty; font-size: 13px; font-weight: 400; }
.empty-description { max-width: 320px; margin: 6px 0 0; color: $theme-text-empty; font-size: 12px; }
</style>



// WEBPACK FOOTER //
// emptyState.vue?b7bff79c